import { featured } from "@/mocks/community";

export default function Feature() {
  return (
    <section id="feature" className="w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16 w-full">
        <div className="text-center max-w-2xl mx-auto">
          <p className="inline-flex items-center gap-2 text-xs font-semibold tracking-wider text-accent-600 uppercase justify-center">
            <span className="w-6 h-px bg-accent-500" aria-hidden="true"></span> 编辑推荐
            <span className="w-6 h-px bg-accent-500" aria-hidden="true"></span>
          </p>
          <h2 className="mt-2 text-2xl md:text-3xl font-black text-foreground-950">本期热议精选</h2>
          <p className="mt-2 text-sm text-foreground-600">
            编辑部从当周讨论里挑出的精华，点进去就能看到完整的时间线与高赞观点。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featured.map((f) => (
            <a
              key={f.key}
              href="#join"
              className="group flex flex-col rounded-2xl bg-background-100 border border-background-200 overflow-hidden hover:border-accent-300 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={f.image}
                  alt={`${f.title} - ${f.summary}`}
                  title={f.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/95 text-accent-700 text-xs font-bold">
                  {f.tag}
                </span>
              </div>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <p className="text-[11px] font-semibold text-primary-500">{f.board}</p>
                <h3 className="mt-1.5 text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-accent-700 transition-colors">
                  {f.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 line-clamp-2 flex-1">{f.summary}</p>
                <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500 border-t border-background-200 pt-3">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-accent-600" aria-hidden="true"></i> {f.replies} 条讨论
                  </span>
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-eye-line text-accent-600" aria-hidden="true"></i> {(f.views / 1000).toFixed(1)}k 浏览
                  </span>
                  <span className="ml-auto text-accent-600 inline-flex items-center gap-1 font-semibold whitespace-nowrap">
                    去围观 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}